import { queryOptions, useQuery } from '@tanstack/react-query';

import type { FamilyHubResponse } from '~entities/family/model/family.type';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getFamilyHub = async (familyId: string) => {
  const response = await baseAPI.get<FamilyHubResponse>(
    `/v2/families/${familyId}`,
  );
  return response.data;
};

export const getFamilyHubOptions = (familyId?: string) =>
  queryOptions({
    queryKey: [KEYS.FAMILY_HUB, familyId],
    queryFn: () => getFamilyHub(familyId!),
    staleTime: 1000 * 60 * 2,
    enabled: !!familyId,
  });

export const useGetFamilyHub = (familyId?: string) => {
  return useQuery(getFamilyHubOptions(familyId));
};
